import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import { Modal, Button } from 'react-bootstrap';
import Spinner from '../../layout/Spinner';
import { Link } from 'react-router-dom';
import { parseJSON } from '../../utils/helpers';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const Rules = () => {
  const dispatch = useDispatch();
  const { rules, actions, conditions, timeTemplates } = useSelector((state) => state.general);
  const [showModal, setShowModal] = useState(false);
  const [ruleToDelete, setRuleToDelete] = useState(null);
  const [changeNameClicked, setChangeNameClicked] = useState(false);
  const [newName, setNewName] = useState('');
  const [showInactive, setShowInactive] = useState(true);

  const [searchField, setSearchField] = useState('name');
  const [searchValue, setSearchValue] = useState('');

  const columns = [
    { id: 'id', label: 'ID', minWidth: 180 },
    { id: 'name', label: 'Name', minWidth: 160 },
    { id: 'condition', label: 'Condition', minWidth: 180 },
    { id: 'action', label: 'Action', minWidth: 160 },
    { id: 'frequency', label: 'Frequency', minWidth: 100 },
    { id: 'status', label: 'Status', minWidth: 100 },
    { id: 'timeTemplateId', label: 'Time Template ID', minWidth: 100 },
    { id: 'details', label: 'Details', minWidth: 130 },
  ];

  useEffect(() => {
    dispatch(apiAction({ reduxField: 'rules', route: 'rules/getRules' }));
    dispatch(apiAction({ reduxField: 'actions', route: 'actions/getActions' }));
    dispatch(apiAction({ reduxField: 'conditions', route: 'conditions/getConditions' }));
    dispatch(
      apiAction({
        reduxField: 'timeTemplates',
        route: 'timeTemplates/getTimeTemplates',
      }),
    );
  }, [dispatch]);

  const handleDelete = (ruleId) => {
    dispatch(generalSet({ reduxField: 'rules', value: rules.filter((rule) => rule._id !== ruleId) }));
    dispatch(apiAction({ reduxField: 'deletedRule', route: 'rules/deleteRuleById', ruleId }));
    setShowModal(false);
  };

  const openModal = (rule) => {
    setRuleToDelete(rule);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setRuleToDelete(null);
  };
  console.log({ rules, actions, conditions });
  return rules && actions && conditions ? (
    <div className='p-4 mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center'>
        <div className='col-lg-12 d-flex justify-content-center border-bottom' data-aos='fade-up' data-aos-delay='200'>
          <h1>Rules</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 mb-4 pt-lg-0'>
        <Link to='/createRule' className='btn btn-outline-dark'>
          Create a Rule
        </Link>
      </div>
      <div className='row d-flex justify-content-center mb-4'>
        <div className='col-md-6 d-flex justify-content-center'>
          <div className='btn-group'>
            <button className='btn btn-outline-secondary disabled border-0'>
              <i className='fas fa-search'></i>
            </button>
            <select value={searchField} onChange={(e) => setSearchField(e.target.value)} className='form-control'>
              <option value='name'>Name</option>
              <option value='_id'>ID</option>
              <option value='condition'>Condition</option>
              <option value='action'>Action</option>
            </select>
            <input type='text' className='form-control' onChange={(e) => setSearchValue(e.target.value)} />
          </div>
        </div>
      </div>
      <div className='row d-flex justify-content-center mb-4'>
        <div>
          <input
            className='mr-2'
            type='checkbox'
            defaultChecked={true}
            onChange={(e) => setShowInactive(e.target.checked)}
          />
          Show Inactive Rules
        </div>
      </div>
      <TableContainer component={Paper} sx={{ maxHeight: '65vh', overflow: 'auto' }}>
        <Table stickyHeader size='small' sx={{ minWidth: 900 }}>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.id} style={{ minWidth: col.minWidth, fontWeight: 'bold' }}>
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rules.map((rule) => {
              if (!showInactive && rule.isActive === false) {
                return null;
              }
              if (searchField === 'name' && rule.name.toLowerCase().includes(searchValue.toLowerCase()) === false) {
                return null;
              }
              if (searchField === '_id' && rule._id.toLowerCase().includes(searchValue.toLowerCase()) === false) {
                return null;
              }
              if (searchField === 'condition') {
                const conditionIds = conditions
                  .filter((con) => con.name.toLowerCase().includes(searchValue.toLowerCase()))
                  .map((con) => con._id);
                if (!conditionIds.includes(rule.conditionId)) {
                  return null;
                }
              }
              if (searchField === 'action') {
                const actionIds = actions
                  .filter((act) => parseJSON(act.actionData)?.name.toLowerCase().includes(searchValue.toLowerCase()))
                  .map((act) => act._id);
                if (!actionIds.includes(rule.actionId)) {
                  return null;
                }
              }

              return (
                <TableRow key={rule._id} hover>
                  <TableCell>{rule._id}</TableCell>
                  <TableCell>
                    {changeNameClicked === rule._id ? (
                      <div>
                        <input
                          type='text'
                          defaultValue={newName}
                          className='form-control form-control-sm'
                          onChange={(e) => setNewName(e.target.value)}
                        />
                        <div className='mt-1'>
                          <button
                            className='btn btn-sm btn-success me-1'
                            onClick={() => {
                              dispatch(
                                apiAction({
                                  reduxField: 'rule',
                                  route: `rules/updateRuleById`,
                                  ruleId: rule._id,
                                  changes: { name: newName },
                                }),
                              );
                              dispatch(
                                generalSet({
                                  reduxField: 'rules',
                                  value: rules.map((r) => (r._id === rule._id ? { ...r, name: newName } : r)),
                                }),
                              );
                              setChangeNameClicked(undefined);
                              setNewName(undefined);
                            }}
                          >
                            Save
                          </button>
                          <button
                            className='btn btn-sm btn-secondary'
                            onClick={() => {
                              setChangeNameClicked(undefined);
                              setNewName(undefined);
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className='btn-group'>
                        <Link className='btn btn-sm btn-outline-dark' to={`/rule/${rule._id}`}>
                          <b>{rule.name}</b>
                        </Link>
                        <button
                          className='btn btn-sm btn-outline-primary'
                          onClick={() => {
                            setChangeNameClicked(rule._id);
                            setNewName(rule.name);
                          }}
                        >
                          <i className='fas fa-edit'></i>
                        </button>
                      </div>
                    )}
                  </TableCell>
                  <TableCell>
                    <Link className='text-primary' to={`/condition/${rule.conditionId}`}>
                      {conditions.find((con) => con._id === rule.conditionId)?.name}
                    </Link>
                  </TableCell>
                  <TableCell>
                    {(() => {
                      const action = actions.find((act) => act._id === rule.actionId);
                      const actionData = action?.actionData ? parseJSON(action.actionData) : {};
                      return (
                        <Link className='text-primary' to={`/action/${rule.actionId}`}>
                          {actionData.name}
                        </Link>
                      );
                    })()}
                  </TableCell>
                  <TableCell>{rule.frequency}</TableCell>
                  <TableCell>
                    <button
                      className={`btn btn-sm btn-${rule.isActive ? 'primary' : 'outline-secondary'}`}
                      onClick={() => {
                        dispatch(
                          apiAction({
                            reduxField: 'rule',
                            route: `rules/updateRuleById`,
                            ruleId: rule._id,
                            changes: { isActive: !rule.isActive },
                          }),
                        );
                        dispatch(
                          generalSet({
                            reduxField: 'rules',
                            value: rules.map((r) => (r._id === rule._id ? { ...r, isActive: !r.isActive } : r)),
                          }),
                        );
                      }}
                    >
                      {rule.isActive ? 'Active' : 'Inactive'}
                    </button>
                  </TableCell>
                  {Array.isArray(timeTemplates) ? (
                    <TableCell>{timeTemplates.find((tt) => tt._id === rule.timeTemplateId)?.name || 'N/A'}</TableCell>
                  ) : (
                    <TableCell>Loading...</TableCell>
                  )}
                  <TableCell>
                    <div className='btn-group'>
                      <Link className='btn btn-sm btn-outline-primary' to={`/rule/${rule._id}`}>
                        View
                      </Link>
                      <button className='btn btn-sm btn-outline-danger' onClick={() => openModal(rule)}>
                        <i className='fa fa-trash' aria-hidden='true'></i>
                      </button>
                      <Link className='btn btn-sm btn-outline-primary' to={`/logsbyruleid/${rule._id}`}>
                        <i className='fa fa-history' aria-hidden='true'></i>
                      </Link>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete the rule "{ruleToDelete?.name}"?</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={closeModal}>
            Cancel
          </Button>
          <Button variant='danger' onClick={() => handleDelete(ruleToDelete._id)}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  ) : (
    <Spinner />
  );
};

export default Rules;
